export default "__VITE_ASSET__CRDFb926__"